import * as constants from "./constants";
import * as apiHelper from '../../apiHelper';
import * as blobHelper from '../../azureBlobHelper';

import { setUserData, pushError, popError, navigateTo, setUserLoggedIn, pushSuccess, getQueryRedirectLink, getQuerySuccessRedirectLink } from '../global/actions';
import { PAGE_ROUTES } from "../../constants/pageRoutes";
import { MAGIC_NUMBER } from "../../constants/magicNumbers";
import { getUserInfo } from "../dashboard/actions";

const controller = 'users';

export function updateFormData(formData) {
  return {
    type: constants.UPDATE_FORM_DATA,
    data: formData
  }
}
export function reinitializeFormData() {
  return {
    type: constants.REINITIALIZE_FORM_DATA
  }
}

export function saveFormState() {
  return {
    type: constants.SAVE_FORM_STATE
  }
}

export function loadFormState(state) {
  return {
    type: constants.LOAD_FORM_STATE,
    data: state
  }
}

export function setTempUserId(id) {
  return {
    type: constants.SET_TEMP_USER_ID,
    data: id
  }
}

export function clearTempUserId() {
  return {
    type: constants.CLEAR_TEMP_USER_ID
  }
}

const dispatchAnyJsonError = (dispatch, json, errType = "generic") => {
  if (!!json.error) {

    dispatch(pushError({ errType: errType, message: json.error }));
    return true;
  }

  return false;
}

const onLoginComplete = (dispatch, json, nextLink) => {
  if (dispatchAnyJsonError(dispatch, json))
    return;

  dispatch(clearTempUserId());
  dispatch(setUserLoggedIn(json.user._id, json.token));
  dispatch(setUserData(json.user));
  dispatch(navigateTo(nextLink));
}

const onSocialLoginResponse = (dispatch, json) => {
  if (!!json.phoneNumberExists) {
    let redirectLink = getQueryRedirectLink();
    redirectLink = !!redirectLink ? redirectLink : PAGE_ROUTES.DASHBOARD;
    onLoginComplete(dispatch, json, redirectLink);
    return;
  }

  dispatch(setTempUserId(json.user._id));
  dispatch(navigateTo(`${PAGE_ROUTES.ADD_PHONE_NUMBER}`))
}

const onOTPSentResponse = (dispatch, json) => {
  if (json.error) {
    dispatch(pushError(json.error));
    throw json.error;
  }

  dispatch(pushSuccess('OTP Sent!'));
}

const onAccountCreationComplete = (dispatch, json) => {
  if (json.message) {
    let error = {
      errType: 'paymentmethod',
      message: `An error occurred in validating credit card: ${json.message}`
    };
    dispatch(pushError(error));
  } else {
    dispatch(updateFormData(json));
  }
}

const onNeedlessVerificationComplete = (dispatch, json) => {
  if (dispatchAnyJsonError(dispatch, json))
    return;

  dispatch(navigateTo(PAGE_ROUTES.COMPLETE_PROFILE));
}

const onAccountDetailsUpdated = (dispatch, getState, json, shouldRedirect = true, shouldUpdateProfile = true) => {
  if (dispatchAnyJsonError(dispatch, json)) {
    throw json.error;
  }

  if (!shouldUpdateProfile)
    return;

  const state = getState();
  dispatch(getUserInfo(state.Global.userId))
    .then(() => {
      dispatch(pushSuccess('Account Details Updated Sucessfully!'));

      if (shouldRedirect) {
        setTimeout(() => {
          let redirectLink = getQueryRedirectLink();

          if (!redirectLink)
            redirectLink = getQuerySuccessRedirectLink();

          dispatch(navigateTo(redirectLink ? redirectLink : PAGE_ROUTES.DASHBOARD));
        }, MAGIC_NUMBER.QUICK_REDIRECT_DELAY);
      }
    })
}

export function updateProfilePhoto(photo) {
  return (dispatch, getState) => {
    let state = getState();
    let formData = state.Registration.formData;
    let modifiedFormData = {
      ...formData
    }
    dispatch(updateFormData(modifiedFormData));
    dispatch(setUserProfilePhoto(photo));
  }
}

export function setUserProfilePhoto(photo) {
  return {
    type: constants.UPDATE_PROFILE_PHOTO,
    data: photo
  }
}

export function checkEmail(email) {
  return (dispatch, getState) => {
    return apiHelper.apiPost(controller, { email: email }, null, 'checkEmail')
      .then(response => response.json())
      .then(json => {
        let state = getState();
        let { Registration } = state;
        if (json.emailAvailable) {
          Registration.formData.emailValid = true;
        } else {
          Registration.formData.emailValid = false;
        }
        dispatch(updateFormData(Registration.formData));
      })
  }
}

export function createUser() {
  return (dispatch, getState) => {
    let state = getState();
    let { Registration } = state;
    return apiHelper.apiPost(controller, Registration.formData)
      .then(response => response.json())
      .then(json => {
        if (dispatchAnyJsonError(dispatch, json, 'registration'))
          return;

        if (Registration.photo)
          blobHelper.createBlob(Registration.photo, json.user._id);

        dispatch(reinitializeFormData());
      })
  }
}

export function createAffirmCustomer(formData) {
  return (dispatch) => {
    dispatch(popError('paymentmethod'));
    return apiHelper.apiPost('blueswipe/customer', formData)
      .then(response => response.json())
      .then(json => {
        if (json.message) {
          dispatch(pushError(json.message));
          throw json.message;
        }
        return json;
      })
  }
}

export function createCustomer(formData) {
  return (dispatch) => {
    dispatch(popError('paymentmethod'));
    return apiHelper.apiPost('blueswipe/customer', formData)
      .then(response => {
        if (response.status !== 200)
          throw response.statusText;

        return response.json()
      })
      .then(json => {
        onAccountCreationComplete(dispatch, json);
        return json;
      })
      .catch(error => {
        dispatch(pushError("Billing Account could not be created. A server error occurred!"));
        throw error;
      })
  }
}

export function createAccount(formData) {
  return (dispatch) => {
    dispatch(popError('paymentmethod'));
    return apiHelper.apiPost('blueswipe/account', formData)
      .then(response => {
        if (response.status !== 200)
          throw response.statusText;

        return response.json()
      })
      .then(json => {
        onAccountCreationComplete(dispatch, json);
        return json;
      })
      .catch(error => {
        dispatch(pushError("Billing Account could not be created. A server error occurred!"));
        throw error;
      })
  }
}


export function sendVerificationMail(email, userType, firstName, lastName, password) {
  return async (dispatch, getState) => {
    return apiHelper.apiPost('sendemail', { email, userType, firstName, lastName, password })
      .then(response => response.json())
      .then(json => {
        if (dispatchAnyJsonError(json))
          return;

        dispatch(pushSuccess('Verification Mail Sent!'));
      })
  }
}

export function verifyEmail(token, e) {
  return (dispatch, getState) => {
    return apiHelper.apiPost('verifyemail', { token, e })
      .then(response => response.json())
      .then(json => {
        onLoginComplete(dispatch, json, PAGE_ROUTES.DASHBOARD);
      })
  }
}


export function sendOTP(firstName, lastName, userType, phoneNumber, email, password) {
  return (dispatch, getState) => {
    return apiHelper.apiPost('sendotp', { firstName, lastName, userType, phoneNumber, email, password })
      .then(response => response.json())
      .then(json => {
        onOTPSentResponse(dispatch, json);
      })
  }
}

export function sendOTPForSocial(phoneNumber, id) {
  return (dispatch, getState) => {
    return apiHelper.apiPost('sendotp', { phoneNumber, id, social: true })
      .then(response => response.json())
      .then(json => {
        onOTPSentResponse(dispatch, json);
      })
  }
}

export function sendEmailForSocial(email, userType, id) {
  return (dispatch, getState) => {
    return apiHelper.apiPost('sendemail', { email, userType, id, social: true })
      .then(response => response.json())
      .then(json => {
        onNeedlessVerificationComplete(dispatch, json)
      })
  }
}


export function verifyOTP(userType, phoneNumber, otp, id = null) {
  let payload = { userType, phoneNumber, otp }
  if (!!id)
    payload = { ...payload, id };
  return (dispatch, getState) => {
    return apiHelper.apiPost('verifyotp', payload)
      .then(response => response.json())
      .then(json => {
        onLoginComplete(dispatch, json, PAGE_ROUTES.COMPLETE_PROFILE);
      })
  }
}

export function loginUsingGoogle(token, userType) {
  return (dispatch, getState) => {
    return apiHelper.apiPost('auth/google', { token, userType })
      .then(response => response.json())
      .then(json => {
        onSocialLoginResponse(dispatch, json);
      })
  }
}

export function loginUsingFacebook(token, userType) {
  return (dispatch, getState) => {
    return apiHelper.apiPost('auth/facebook', { token, userType })
      .then(response => response.json())
      .then(json => {
        onSocialLoginResponse(dispatch, json);
      })
  }
}

export function updateBankDetails(token, userType, brand, lastFour, accountNumber, routingNumber,
  sourceId, shouldRedirect = true, shouldUpdateProfile = true) {
  return (dispatch, getState) => {
    const data = {
      userType: userType,
      accounts: [
        {
          brand,
          lastFour,
          accountNumber,
          routingNumber,
          sourceId
        }
      ]
    }

    return apiHelper.apiPost('user/update-bank', data, token)
      .then(response => response.json())
      .then(json => {
        onAccountDetailsUpdated(dispatch, getState, json, shouldRedirect, shouldUpdateProfile);
        return json;
      });
  }
}

export function updateCreditCardDetails(token, brand, lastFour, month, year, sourceId,
  shouldRedirect = true, shouldUpdateProfile = true) {
  return (dispatch, getState) => {
    const data = {
      creditCards: [
        {
          brand,
          lastFour,
          month,
          year,
          sourceId
        }
      ]
    }

    return apiHelper.apiPost('user/update-credit-card', data, token)
      .then(response => response.json())
      .then(json => {
        onAccountDetailsUpdated(dispatch, getState, json, shouldRedirect, shouldUpdateProfile);
        return json;
      })
  }
}

export function updateBillingAddress(token, userType, values, accountType) {
  return (dispatch, getState) => {
    const data = {
      userType,
      accountType,
      ...values,
    }
    return apiHelper.apiPost('user/update-address', data, token)
      .then(response => response.json())
      .then(json => {
        if (json.error) {
          dispatch(pushError(json.error));
        }
        return json;
      })
  }
}

export function updateProfileDetails(token, userId, userType, profileAbout, profilePhoto, profileLoyalties) {
  return (dispatch, getState) => {
    const data = {
      userType,
      profileAbout,
      profilePhoto,
      profileLoyalties
    }

    const state = getState();
    const { Registration } = state;

    return apiHelper.apiPost('user/update-details', data, token)
      .then(response => response.json())
      .then(json => {
        if (json.error) {
          dispatch(pushError(json.error));
          return;
        }

        if (Registration.photo)
          blobHelper.createBlob(Registration.photo, userId);

        dispatch(pushSuccess('Profile Updated Sucessfully!'));
      })
  }
}
